import { GetStaticProps } from 'next';

import TSTaxonomy from '../../utils/typesense/taxonomy';
import { ITSTaxonomyProductQueryVars } from '../../utils/typesense/types/taxonomy';
import TaxonomyItemPage from '../../components/content/TaxonomyItemPage';
import TSPage from '../../utils/typesense/page';
import cyohProductData from '../../data/cyohProductData';

export default TaxonomyItemPage;

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await TSPage.getBySlug('shop');

  const defaultQueryVars = TSTaxonomy.getDefaultTsQueryVars();
  const taxonomyProductQueryVars: ITSTaxonomyProductQueryVars = {
    ...defaultQueryVars,
    pinnedHits: cyohProductData.id + ':2', // Pin the product to results in position 2
  };

  const tsFetchedData = await TSTaxonomy.getProducts(taxonomyProductQueryVars);

  return {
    props: {
      fullHead: pageData?.seoFullHead,
      pageSchemaCode: pageData?.pageSchemaCode ?? '',
      categoryName: pageData?.name,
      popular: [],
      hero: {
        name: pageData?.name,
        sourceUrl: pageData?.thumbnail?.src,
      },
      tsFetchedData: tsFetchedData,
      showPerfectGiftHelper: true,
    },
    revalidate: 43200, // Refresh the generated page every 12 hours,
  };
};
